import { useContext } from 'react';
import { FileSearchContext } from '../components/contexts/FileSearchContext';

export const useFileSearch = () => {
  const {
    keyword,
    isSubmitted,
    handleChange,
    handleSubmit,
    onSubmitted,
  } = useContext(FileSearchContext);
  return { keyword, isSubmitted, handleChange, handleSubmit, onSubmitted };
};
